<template>
    <div>
        <div class="introduction__rules">
            <div class="cursor hide"></div>
            <div class="container-fluid d-flex align-items-center h-100">
                <a href="#" class="backToMain" @click.prevent.stop="toggleRules">
                    <svg fill="currentColor"  width="26.176" height="12.679" viewBox="0 0 26.176 12.679">
                        <use  xlink:href="#right-arrow"></use>
                    </svg>
                    <template v-for="rule in rules">
                        {{rule.titleReturn}}
                    </template>
                    
                </a>
                <div class="line"></div>
                <!-- <div class="rules-counter">{{currentSlide}}/{{totalSlides}}</div> -->
                <div class="rules__wrapper slider__wrapper">
                    <div class="rules__item slide__item" v-for="rule in rules" :key="rule.id">
                        <div class="rules__item--heading">
                            <p class="rules__item--title"><span>{{rule.title}}</span></p>
                            <p class="rules__item--subtitle"><span>{{rule.subtitle}}</span></p>
                            <a href="#" v-bind:data-target="'rule-' + rule.id" @click.prevent.stop>
                                {{$t('labels.exploreMore')}}
                                <svg fill="currentColor"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.176 12.679">
                                    <use xlink:href="#right-arrow"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="rules__item--image">
                            <img :src="require('@/assets/images/governance/' + rule.image)" alt="">
                            <!-- {{rule.image}} -->
                        </div>
                    </div>
                </div>
                <div :data-text="$t('labels.next')" id="downArrow" class="arrow slider-nav-link">
                    {{$t('labels.next')}}
                </div>
                <div :data-text="$t('labels.previous')" id="upArrow" class="arrow slider-nav-link disabled">
                    {{$t('labels.previous')}}
                </div>
                <!-- <svg id="downArrow" :data-text="$t('labels.next')" class="arrow slider-nav-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"></svg>
                <svg id="upArrow" :data-text="$t('labels.previous')" class="arrow slider-nav-link disabled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"></svg> -->
            </div>
            
        </div>
        <div class="introduction__rules--contents">
            <a href="#" @click.prevent.stop="hideRulesContents" class="introduction__rules--close">
                <svg xmlns="http://www.w3.org/2000/svg" width="22.875" height="22.881" viewBox="0 0 22.875 22.881" fill="currentColor">
                    <use xlink:href="#close-icon"></use>
                </svg>
            </a>
            <div id="rule-1" class="rules__contents">
                <div class="scrollWrapper">
                    <scrollbar class="scrollSettings">
                        <div class="scrollWrapper_inner">
                            <div class="paddingContainer">
                                <h2>{{this.rules[0].detail.title}}</h2>  
                            </div>
                            
                            <companyChart></companyChart>
                            <div class="paddingContainer">
                                <h3>{{this.rules[0].detail.tablehead1}}</h3>
                            <p>
                                {{this.rules[0].detail.tabledes1}}
                            </p>
                            <div class="table-wrapper big">
                                <compositionBOD></compositionBOD>
                            </div>
                            <h3>{{this.rules[0].detail.tablehead2}}</h3>
                            <p>
                                {{this.rules[0].detail.tabledes2}}
                            </p>
                            <div class="table-wrapper big">
                                <bodMeetings></bodMeetings>
                            </div>
                            <ul class="attendance-status">
                                <li>
                                    <span>
                                       <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 12.19 12.19" style="enable-background:new 0 0 12.19 12.19;" xml:space="preserve">
                                            <polygon fill="#fff" points="9.4,2.99 4.82,7.85 2.72,5.82 2.06,6.46 4.81,9.2 10.13,3.58 "/>
                                                <g>
                                                    <defs>
                                                    <rect id="SVGID_1_" width="12.19"  height="12.19"/>
                                                    </defs>
                                                    <clipPath id="SVGID_2_">
                                                    <use xlink:href="#SVGID_1_" style="overflow:visible;"/>
                                                    </clipPath>
                                                    <circle class="st0" cx="6.09" fill="none" stroke="currentColor" cy="6.09" r="5.84"/>
                                                </g>
                                        </svg>
                                    </span>
                                    {{this.rules[0].detail.table.attended}}
                                     
                                </li>
                                <li>
                                    <span>
                                        <svg version="1.1" stroke="currentColor"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.19 12.19" style="enable-background:new 0 0 12.19 12.19;" xml:space="preserve">
                                            <g>
                                                <defs>
                                                    <rect id="SVGID_1_" width="12.19" height="12.19"/>
                                                </defs>
                                                <clipPath id="SVGID_2_">
                                                    <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
                                                </clipPath>
                                                <path class="st0" d="M0.25,6.09c0-3.23,2.62-5.84,5.84-5.84c3.23,0,5.85,2.62,5.85,5.84s-2.62,5.84-5.85,5.84
                                                    C2.87,11.94,0.25,9.32,0.25,6.09z"/>
                                            </g>
                                            <rect x="3.17" y="5.51" width="5.84" height="1.18"/>
                                        </svg>
                                    </span>
                                    {{this.rules[0].detail.table.notApplicable}}
                                </li>
                                <li>
                                    <span>
                                        <svg version="1.1" stroke="#fff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.19 12.19" style="enable-background:new 0 0 12.19 12.19;" xml:space="preserve">
                                            <rect x="5.51" y="3.17" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.5246 6.0946)" width="1.18" height="5.84"/>
                                            <g>
                                                <defs>
                                                    <rect id="SVGID_1_" width="12.19" height="12.19"/>
                                                </defs>
                                                <clipPath id="SVGID_2_">
                                                    <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
                                                </clipPath>
                                                <path class="st0" d="M0.25,6.09c0-3.23,2.62-5.84,5.84-5.84c3.23,0,5.85,2.62,5.85,5.84s-2.62,5.84-5.85,5.84
                                                    C2.87,11.94,0.25,9.32,0.25,6.09z"/>
                                            </g>
                                            <rect x="3.17" y="5.51" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.5245 6.0944)" width="5.84" height="1.18"/>
                                            <rect x="5.51" y="3.17" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.5246 6.0943)" width="1.18" height="5.84"/>
                                        </svg>

                                    </span>
                                    {{this.rules[0].detail.table.absent}}
                                </li>
                            </ul>
                            <ul class="meeting_content">
                                <li v-for="text in this.rules[0].detail.mbm.listing" :key="text">{{text}}</li>
                            </ul>
                            <h3>{{this.rules[0].detail.mbm.title}}</h3>
                            <p v-for="text in this.rules[0].detail.mbm.contents" :key="text">{{text}}</p>
                            </div>
                         </div>
                    </scrollbar>
                </div>
            </div>
             <div id="rule-2" class="rules__contents">
                <div class="scrollWrapper">
                    <scrollbar class="scrollSettings">
                        <div class="scrollWrapper_inner">
                           <div class="paddingContainer">
                                <h2 >{{this.rules[1].detail.title}}</h2> 
                                <h3>{{this.rules[1].detail.roletitle}}</h3> 
                                <p v-for="text in this.rules[1].detail.contents" :key="text">{{text}}</p>
                                <h3>{{this.rules[1].detail.achivementTitle}}</h3>
                                <ul class="meeting_content">
                                    <li v-for="text in this.rules[1].detail.listing" :key="text">{{text}}</li>
                                </ul>
                                <h3>{{this.rules[1].detail.bcTitle}}</h3>
                                <p v-for="text in this.rules[1].detail.boardcommittees" :key="text">{{text}}</p>
                            </div>
                         </div>
                    </scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import companyChart from "@/components/governance/partials/companyChart.vue";
import compositionBOD from '@/components/governance/partials/compositionBOD'
import bodMeetings from '@/components/governance/partials/bodMeetings'
import {gsap} from "gsap"
import { Draggable } from "gsap/Draggable";
gsap.registerPlugin(Draggable);
let slides = [];
let oldSlide = 0;
let activeSlide = 0;
let offsets = [];
let ih = window.innerHeight;
var currentSection , prevSection,prevImage, nextSection , nextImg ,prvImg ,prevSlider , nextSlider;
    export default {
        props:{
            rules: Array
        },
        components:{
            companyChart,
            compositionBOD,
            bodMeetings
        },
        data(){
            return{
                currentSlide: 1,
                totalSlides: slides.length,
                scrollSettings: {
                    maxHeight: 100,
                    horizontal:false,
                }
            }
        },
        mounted(){
            setTimeout(() => {
                this.initSlider();
            }, 200);
            //window.addEventListener("wheel", this.slideAnim);
            window.addEventListener("resize", this.newSize);
            var rules = document.querySelectorAll(".rules__item a");

            rules.forEach((rule)=>{
                rule.addEventListener("click", this.rulesContents);
            });
            //document.querySelector(".rules__item a").addEventListener("click", this.rulesContents);
            //this.sliderCustomCursor();
            document.querySelectorAll(".slider-nav-link").forEach(link=>{
                link.addEventListener("mousemove", this.sliderCustomCursor);
                link.addEventListener("mouseout", this.hideCursor);
            });
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            window.addEventListener('resize', () => {
            // We execute the same script as before
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            });
            
        },
        methods:{
            toggleRules: function(e){
                document.querySelector(".introduction__rules").classList.toggle("active");
                this.resetSlides();
                
            },
            initSlider: function(){
                document.querySelector("#upArrow").addEventListener("click", this.slideAnim);
                document.querySelector("#downArrow").addEventListener("click", this.slideAnim);
                slides = document.querySelectorAll(".slide__item");
                this.newSize();
            },
            animateFirstSlide: function(){
                activeSlide=0;
                let currentSlide = slides[activeSlide];
                let prevSlide = slides[slides.length-1];
                currentSlide.classList.add("currentSlide");
                // prevSlide.classList.add("prevSlide");
            },
            slideDown: function(){
                //const slides = document.querySelectorAll(".rules__item");
                var tl = gsap.timeline();
                var prevSlide = document.querySelector('.prevSlide');
                if(prevSlide){
                    var prevImage = prevSlide.querySelector('img');
                    tl.to(prevImage,{ y:"-100%", rotate : -20, x : "40%", duration: 0.5 })
                    tl.to(".prevSlide .rules__item--title span",{ y:"-100%", autoAlpha: 0, duration:.3 }, "-=0.5")
                    tl.to(".prevSlide .rules__item--subtitle span",{ y:"-100%", autoAlpha: 0, duration: .3 }, "-=0.5")
                }
                var currentSlide = document.querySelector('.currentSlide');
                
                var currentImage = currentSlide.querySelector('img');
                tl
                .fromTo(".currentSlide .rules__item--title span",  {y: "100%", autoAlpha : 0}, {y: 0  , opacity : 1, autoAlpha : 1, duration: 0.8}, "-=0.5")
                .fromTo(currentImage, {y: "100%" ,rotate : -80 , autoAlpha : 0}, {y: "20%" , rotate : -10 ,x:"20%" , autoAlpha : 1, duration: 1}, "-=0.5")
                .fromTo(".currentSlide .rules__item--subtitle span",  {y: "100%", autoAlpha : 0}, {y: 0  , opacity : 1, autoAlpha : 1, duration: 0.8}, "-=0.5")
            },
            slideUp: function(){
                var tl = gsap.timeline();
                var prevSlide = document.querySelector('.prevSlide');
                var currentSlide = document.querySelector('.currentSlide');
                var prevImage = prevSlide.querySelector('img');
                var currentImage = currentSlide.querySelector('img');
                tl
                .to(prevImage,0.5,{ y:"100%", rotate : -20, x : "40%" })
                .to(".prevSlide .rules__item--title span",.3,{ y:"100%", opacity : 0 }, "-=0.5")
                .to(".prevSlide .rules__item--subtitle span",.3,{ y:"100%", opacity : 0 }, "-=0.5")
                .fromTo(".currentSlide img", 1.2, {y: "-100%" ,rotate : -40 , x : "30%" , autoAlpha : 0}, {y: "20%" , rotate : 10 ,x:"10%" , autoAlpha : 1}, "-=0.5")
                .fromTo(".currentSlide .rules__item--title span", 0.3, {y: "-100%" , autoAlpha : 0}, {y: 0 , autoAlpha : 1 }, "-=0.5")
                .fromTo(".currentSlide .rules__item--subtitle span", 0.3, {y: "-100%" , autoAlpha : 0}, {y: 0 , autoAlpha : 1 }, "-=0.5")
            },
            slideAnim: function(e) {
                oldSlide = activeSlide;
                var downArrow = document.querySelector("#downArrow");
                var upArrow = document.querySelector("#upArrow");
                for (let i = 0; i < slides.length; i++) {
                    slides[i].classList.remove("prevSlide");
                    slides[i].classList.remove("currentSlide");
                }
                if (e.target.id == "" && e.type!="wheel") {
                    // activeSlide = offsets.indexOf(dragMe[0].endY);
                    // console.log("active slide: " + activeSlide);
                } else {
                    if (gsap.isTweening(".slider__wrapper")) {
                        return;
                    }
                    if (e.target.id === "downArrow" || e.target.id === "upArrow") {
                        activeSlide =
                        e.target.id === "downArrow" ? (activeSlide += 1) : (activeSlide -= 1);
                        nextSlider = activeSlide;
                        //scroll
                    } else {
                        activeSlide = e.deltaY > 0 ? (activeSlide += 1) : (activeSlide -= 1);
                        prevSlider = activeSlide;
                    }
                }
                
                activeSlide = activeSlide < 0 ? 0 : activeSlide;
                activeSlide =
                activeSlide > slides.length - 1 ? slides.length - 1 : activeSlide;
                if (oldSlide === activeSlide) {
                return;
                }
                if(activeSlide==slides.length-1){
                    downArrow.classList.add("disabled");
                    upArrow.classList.remove("disabled");
                }
                else if(activeSlide<= 0 || activeSlide==0){
                    downArrow.classList.remove("disabled");
                    upArrow.classList.add("disabled");
                }
                else{
                    downArrow.classList.remove("disabled");
                    upArrow.classList.remove("disabled");
                }
                // scroll Animation
                if (e.target.id != "dragger") {
                    gsap.to(".slider__wrapper", {
                        y: offsets[activeSlide], duration: 0.8,
                        ease: "power2.inOut"
                    });
                };
                if(activeSlide>=0 || activeSlide<=slides.length){
                    if(e.target.id=="downArrow"){
                        let currentSlide = slides[activeSlide];
                        let prevSlide = slides[activeSlide-1];
                        currentSlide.classList.add("currentSlide");
                        prevSlide.classList.add("prevSlide");
                        this.slideDown();
                        
                    }
                    else{
                        let currentSlide = slides[activeSlide];
                        let prevSlide = slides[activeSlide + 1];
                        currentSlide.classList.add("currentSlide");
                        prevSlide.classList.add("prevSlide");
                        this.slideUp();

                    }
                }
            },
            newSize: function() {
                offsets = [];
                ih = window.innerHeight;
                gsap.set(".slider__wrapper", { height: slides.length * ih });
                // gsap.set(slides, { height: ih });
                for (let i = 0; i < slides.length; i++) {
                offsets.push(-slides[i].offsetTop);
                gsap.set(slides[i], { height: ih });
                }
                gsap.set(".slider__wrapper", { y: offsets[activeSlide] });
            },
            resetSlides: function(){
                gsap.set(".slider__wrapper", { y: 0 });
                for (let i = 0; i < slides.length; i++) {
                    slides[i].classList.remove("prevSlide");
                    slides[i].classList.remove("currentSlide");
                }
                document.querySelector("#upArrow").classList.add("disabled");
                document.querySelector("#downArrow").classList.remove("disabled");
            },
            rulesContents: function(e){
                var target = e.target.dataset.target;
                document.querySelector(".introduction__rules--contents").classList.add("show");
                document.querySelector('#' + target).classList.add("active");
                document.querySelector(".introduction__rules").style.pointerEvents  = "none";
            },
            hideRulesContents: function(e){
                var rc = document.querySelector(".introduction__rules--contents");
                var c = rc.querySelectorAll("div");
                rc.classList.remove("show");
                c.forEach(item => {
                    item.classList.remove("active");
                });
                 document.querySelector(".introduction__rules").style.pointerEvents = "all";
            },
            sliderCustomCursor: function(e){
                let cursor = document.querySelector(".cursor");
                let text = e.target.dataset.text;
                if(e.target.id=="downArrow"){
                    cursor.classList.remove("hide");
                    cursor.textContent = text;
                    cursor.classList.add("next");
                    cursor.classList.remove("prev");
                }
                else if(e.target.id=="upArrow"){
                    cursor.classList.remove("hide");
                    cursor.textContent = text;
                    cursor.classList.add("prev");
                    cursor.classList.remove("next");
                }
                else{
                    cursor.classList.add("hide");
                }
                 gsap.to(cursor,{x:e.pageX, y: e.pageY, duration: 0.2});
            },
            hideCursor: function(){
                let cursor = document.querySelector(".cursor");
                cursor.classList.add("hide");
            }
        }
    }
</script>

<style lang="scss" scoped>
.introduction{
    &__rules{
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        position: absolute;
        left: 0;
        top: 120%;
        background:#000;
        width: 100%;
        transition: all 0.5s ease;
        background: url(../../assets/images/banners/gov-intro-rules-bg.png) left top no-repeat;
        background-size: cover;
        z-index: 9;
        overflow: hidden;
        .cursor {
            color: #E6E6E6;
            font-weight: 700;
            font-size: rem(13px);
            position: relative;
            width: 80px;
            height: 80px;
            z-index: 1;
            border: 1px solid #E6E6E6;
            border-radius: 50%;
            text-transform: uppercase;
            display: flex;
            justify-content: center;
            align-items: center;
            transform: translate(-50%,-50%);
            
            &::after{
                position: absolute;
                bottom: -15px;
                left: 0;
                right: 0;
                margin: auto;
                content: "\f309";
                font-family: "Font Awesome 5 Free";
                font-weight: 900;
                text-align:center;
                font-size: rem(25px);
            }
            &.prev{
                &::after{
                    bottom: auto;
                    top: -15px;
                    content: "\f30c";
                }
            }
        }
        .cursor{
            @media screen and (max-width: 991px){
                display: none !important;
            }
        }
        .navArrow{
            color: #E6E6E6;
            font-weight: 700;
            font-size: rem(13px);
            width: 80px;
            height: 80px;
            border: 1px solid #E6E6E6;
            border-radius: 50%;
            text-transform: uppercase;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            &::after{
                position: absolute;
                bottom: -15px;
                left: 0;
                right: 0;
                margin: auto;
                content: "\f309";
                font-family: "Font Awesome 5 Free";
                font-weight: 900;
                text-align:center;
                font-size: rem(25px);
            }
            &.prev{
                &::after{
                    bottom: auto;
                    top: -15px;
                    content: "\f30c";
                }
            }
        }
        .hide{
            display: none;
        }

        &.active{
            top: 0;
        }
        .line{
            position: absolute;
            height: 2px;
            width: 100%;
            background: #fff;
            top: 50%;
            z-index: 2;
            @media screen and (max-width:991px){
                top:53%;
            }
            @media screen and (max-width:576px){
                display: none;
            }
        }
        &:after{
            position: absolute;
            left: 0;
            top: 0;
            content:"";
            width: 100%;
            height: 100%;
            z-index: 0;
            background: rgba(5,2,71,0.8);
        }
        .backToMain{
            color:#CECECE;
            font-weight: 600;
            font-size: rem(22px);
            position: absolute;
            top: 125px;
            z-index: 10;
            padding-right: rem(10px);
            svg{
                transform: rotate(270deg);
            }
            @media screen and (max-width:991px){
                top: -25%;
                position: relative;
            }
        }
        .rules-counter{
            position: relative;
        }
        h2{
            font-size: rem(25px);
            font-weight: 700;
            @media screen and (max-width:767px){
                font-size:rem(20px);
            }
        }
        &--contents{
            position: fixed;
            right: -100%;
            top: 0;
            width: 70%;
            height: 100vh;
            transition: all 0.6s ease-in;
            background: rgba(0,0,0,1);
            z-index: 99;
            &.show{
                right: 0;
            }
            @media screen and (max-width:1199px){
                width:80%;
            }
            @media screen and (max-width:991px){
                width:100%;
            }
        }
        &--close{
            color:#fff;
            // position: fixed;
            // right: 25px;
            // top: 20px;
            // z-index: 100;
            transition: all 0.6s ease;
            position: absolute;
            right: 20px;
            top: 20px;
            z-index: 5;
            &:hover{
                transform: rotate(180deg);
            }
        }
    }
    .rules{
        &__wrapper{
            // display: flex;
            // height: calc(100% - 75px);
            height: 100%;
            align-items: center;
            position: absolute;
            top:0;
            width: 100%;
            z-index: 9;
        }
        &__item{
            border: none;
            outline: none;
            width: 100%;
            align-items: flex-start;
            display: flex;
            align-content: center;
            flex-direction: column;
            justify-content: center;
            position: relative;
            &--image{
                position: absolute;
                right: -150px;
                top: 0;
                z-index:1;

                img{
                    max-width: 900px;
                }
                @media screen and (max-width:1600px){
                    top: 50%;
                    transform: translateY(-50%);
                    img{
                        max-width:750px;
                    }
                }
                @media screen and (max-width:1200px){
                    right:-125px;
                    img{
                        max-width:650px;
                    }
                }
                @media screen and (max-width:1025px){
                    right:-40px;
                    // img{
                    //     max-width:450px;
                    // }
                }
                @media screen  and (max-width:991px) and (orientation: landscape) {
                    
                    img{
                        max-width:350px;
                    }
                }
                // @media screen  and (max-width:767px){
                //     top:25%;
                //     img{
                //         max-width:400px;
                //     }
                // }
                @media screen  and (max-width:575px){
                    // top:90px;
                    img{
                        max-width:300px;
                    }
                }
            }
            &--heading{
                width: 100%;
                font-weight: 800;
                color:#CECECE;
                margin-top: rem(60px);
                position:relative;
                z-index:2;
                @media screen and (max-width:991px){
                    margin-top:rem(150px);
                }
            }
            &--title{
                color:#CECECE;
                font-size: rem(150px);
                text-transform: uppercase;
                height: 155px;
                overflow: hidden;
                @media screen and (max-width:1600px){
                    font-size:rem(120px);
                }
                @media screen and (max-width:1200px){
                    height:125px;
                    font-size:rem(100px);
                }
                @media screen and (max-width:991px){
                    height:65px;
                    font-size:rem(65px);
                }
                @media screen and (max-width:575px){
                    height:40px;
                    font-size:rem(45px);
                }
                span{
                    display: inline-block;
                }
            }
            &--subtitle{
                font-size: rem(40px);
                max-width: 50%;
                text-transform: uppercase;
                height: 100px;
                overflow: hidden;
                margin-top: rem(30px);
                @media screen and (max-width:1600px){
                    font-size:rem(35px);
                }
                @media screen and (max-width:1200px) and (min-width:992px){
                    max-width:60%;
                    font-size:rem(30px);
                }
                @media screen and(max-width:991px){
                    height:50px;
                    font-size:rem(25px);
                }
                @media screen and (max-width:575px){
                    max-width:80%;
                }
                span{
                    display: inline-block;
                }
            }
            a{
                background: #CECECE;
                color:#2A2A2A;
                font-size: rem(15px);
                font-weight: 600;
                padding: rem(15px) rem(35px);
                text-transform: uppercase;
                display: inline-block;
                position: relative;
                transition: all 0.5s ease;
                z-index: 3;
                overflow: hidden;
                margin-top: rem(25px);
                svg{
                    margin-left: rem(5px);
                    width: 20px;
                    height: auto;
                    position: relative;
                    top: -1px;
                    z-index: 3;
                }
                &:after{
                    position: absolute;
                    content: "";
                    left: 0%;
                    top: 0%;
                    width: 0%;
                    height: 100%;
                    background: #000;
                    z-index: -1;
                    transition: all 0.5s ease;
                }
                &:hover{
                    color:#fff;
                    text-decoration: none;
                    &:after{
                        width: 100%;
                    }
                }
            }
        }
    }
    @media screen and (max-width:992px) and (min-width:768px){
        .paddingContainer{
            padding-left:40px;
        }
    }
}
.rules{
     
    &__contents{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        h2{
            font-size: rem(43px);
            font-weight: 900;
            color: #fff;
            margin-bottom: 35px;
            @media screen and (max-width:767px){
                font-size:rem(30px);
            }
            @media screen and (max-width:767px){
                font-size:rem(25px);
            }
        }
        h3{
            font-size: rem(25px);
            font-weight: 700;
            padding-top: rem(20px);
            padding-bottom: rem(10px);
            @media screen and (max-width:767px){
                font-size:rem(20px);
            }
        }
        p{
            font-size: rem(18px);
            font-weight: 700;
            line-height: 1.3;
            @media screen and (max-width:767px){
                font-size:rem(15px);
            }
        }
        .scrollWrapper{
            height: calc(100vh - 100px) !important;
            padding-right: rem(20px);
            @media screen and (max-width:1199px){
                padding-right:0;
                >div{
                    padding-right:rem(20px) !important;
                }
            }
            .scrollWrapper_inner{
                padding-right: rem(20px);
            }
        }
        
        padding: rem(80px) rem(30px) rem(50px);
        @media screen and (max-width:991px){
            padding-right:rem(20px);
            padding-left:rem(20px);
        }
        color:#fff;
        // top: 0;
        transition: all 0.6s ease;
        z-index: -99;
        opacity: 0;
        &.active{
            z-index: 1;
            opacity: 1;
        }
        .custom-table {
        margin: 1.875rem 0;
        display: table;
        table-layout: fixed;
        width: 100%;
        .table-heading {
            background: #dedfe0;
            color: #00a982;
            font-size: 25px;
            font-weight: 600;
            padding: 10px;
            border-top: 1px solid #000;
            border-bottom: 1px solid #000;
            @media screen and (max-width:767px){
                font-size:rem(20px);
            }
        }
        .trow {
        display: table;
        table-layout: fixed;
        border-bottom: 1px solid #000;
        width: 100%;
        background: #fff;
        }
        .trow.head {
        background: #dedfe0;
        color: #000;
        border: 0;
        }
        .th {
        color: #000;
        font-weight: 600;
        text-transform: uppercase;
        }
        .th {
        font-size: 16px;
        font-weight: 700;
        padding: 10px;
        border: 0;
        vertical-align: middle;
        @media screen and (max-width:767px){
                font-size:rem(14px);
            }
        }
        .trow {
        display: table;
        table-layout: fixed;
        border-bottom: 1px solid #000;
        width: 100%;
        background: #fff;
}
    }
    .meeting_content{
        li{
            position: relative;
            color: #fff;
            font-size: rem(18px);
            font-weight: 700;
            line-height: 1.3;
            padding-left: rem(20px);
            &:not(:last-child){
                margin-bottom:rem(25px);
            }
            @media screen and (max-width:767px){
                font-size:rem(15px);
            }
            &::before{
                content: "";
                position: absolute;
                height: 10px;
                width: 10px;
                left: 0%;
                top: 5px;
                border-radius: 50%;
                background: #fff;
                
            }
        }
    }
        
        
    }
}
#downArrow{
    bottom: 0px;
}
#upArrow {
    top: 0px;
}
.arrow{
    position: absolute;
    z-index: 9;
    right: 12px;
    opacity: 0.75;
    width: 65%;
    height: 35%;
    stroke-width: 8px;
    stroke: white;
    fill: transparent;
    left:0;
    margin:auto;
    font-size: 0px;
    &.disabled{
        display:none;
    }
    span{
        display: none;
    }
    @media screen and (max-width: 991px){
        span{
            display: flex;
        }
        width: 70px;
        height: 70px;
        left: 0;
        right: 0;
        margin:auto;
        bottom: rem(150px);
        color: #E6E6E6;
        font-weight: 700;
        font-size: rem(13px);
        border: 1px solid #E6E6E6;
        border-radius: 50%;
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
        &::after{
            position: absolute;
            bottom: -15px;
            left: 0;
            right: 0;
            margin: auto;
            content: "\f309";
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            text-align:center;
            font-size: rem(25px);
        }
        &#downArrow{
            bottom: rem(70px);
        }
        &#upArrow{
            top: rem(150px);
            bottom: auto;
            &:after{
                bottom: auto;
                top: -15px;
                content: "\f30c";
            }
        }
        @media screen and (max-width: 575px){
            right: rem(10px);
            left: auto;
        }
    }
    
} 

@media screen and (max-width:767px){
    .scrollWrapper{
        /deep/{
            .__view{
                    min-width:auto !important;
                    width:100% !important;
                }
        }
    }
}

// arabic
[lang="ar"] {
    .introduction{
        
    &__rules{
        
        right: 0;
        left: auto;
        background-position: right top;
        .cursor {
            margin-left: 0;
            margin-right: auto;
        }
        &--contents{
            left: -100%; right: auto;
            
            &.show{
                left: 0; right: auto;
            }
        }
        &--close{
            left: 20px; right: auto;
        }
    }
    .rules{
        
        &__item{
            
            &--image{
                left: -150px; right: auto;
                transform: translateY(0%) rotateY(180deg);
                
                @media screen and (max-width:1600px){
                    transform: translateY(-50%) rotateY(180deg);
                }
                @media screen and (max-width:1200px){
                    left:-125px; right: auto;
                }
                @media screen and (max-width:1025px){
                    left:-40px; right: auto;
                }
            }
            
            
            a{
                
                svg{
                    margin-right: rem(5px);
                    margin-left: 0;
                    
                }
                &:after{
                    
                    right: 0%;
                    left: auto;
                }
                
            }
        }
    }
    @media screen and (max-width:992px) and (min-width:768px){
        .paddingContainer{
            padding-right:40px; padding-left: 0;
        }
    }
    }
    .rules{
        
        &__contents{
            
            
            .scrollWrapper{
                padding-left: rem(20px);
                padding-right: 0;
                @media screen and (max-width:1199px){
                    padding-left:0;
                    >div{
                        padding-left:rem(20px) !important;
                        padding-right: 0;
                    }
                }
                .scrollWrapper_inner{
                    padding-left: rem(20px);
                    padding-right: 0;
                }
            }
            
            
            
            
        .meeting_content{
            list-style: none;
            direction: rtl;
            li{
                
                padding-right: rem(20px);
                padding-left: 0;
                &::before{
                    
                    right: 0%; left: auto;
                    
                    
                }
            }
        }
            
            
        }
    }
    
    
    .arrow{
        
        right:0; left: auto;
        
        @media screen and (max-width: 991px){
            
            @media screen and (max-width: 575px){
                left: rem(10px);
                right: auto;
            }
        }
        
    } 
}


</style>